export const MENU_ALIGNMENT = {
  left: 'bottom-start',
  right: 'bottom-end',
} as const;
